module.exports = __webpack_public_path__ + "static/media/7a.fce23571.jpg";